import React from 'react';
import Text from './base';

const Paragraph = props => (
  <Text defaultTag="p" variant="paragraph" {...props} />
);

export default Paragraph;
